/**
 * Sincroniza el precio del botón "Añadir al carrito" con el plan/variante seleccionado
 * en el widget de Shopify Subscriptions.
 *
 * El widget renderiza un bloque de opciones por CADA variante (radios cuyo name acaba en
 * "_<variantId>") y cada bloque mantiene su propio radio marcado. Por eso hay que filtrar
 * por la variante seleccionada y NO coger el primer radio marcado cualquiera.
 *
 * Fuente del precio: el .in_widget_price del grupo cuyo radio (de la variante activa) está marcado.
 * Destino: .add-to-cart-text__content .custom-price .price (todos los que existan).
 */
(function () {
  document.querySelector('.rating-stars-block__inner')?.addEventListener('click', () => {
    document.querySelector('.jm-button.jm-button--primary.jm-action-buttons__button')?.click();
  });

  var SOURCE_FIELDSET = '.shopify_subscriptions_fieldset';
  var BUTTON_PRICE = '.add-to-cart-text__content .custom-price .price';

  // Variante seleccionada actualmente (picker nativo del tema, o ?variant=).
  function getSelectedVariantId() {
    var r = document.querySelector('variant-picker input[type="radio"]:checked');
    if (r && r.getAttribute('data-variant-id')) return r.getAttribute('data-variant-id');
    return new URLSearchParams(window.location.search).get('variant');
  }

  // Precio del plan activo PARA LA VARIANTE SELECCIONADA.
  function getActivePriceText() {
    var fs = document.querySelector(SOURCE_FIELDSET);
    if (!fs) return null;

    var vid = getSelectedVariantId();
    var radio = vid
      ? fs.querySelector('input[type="radio"][name$="_' + vid + '"]:checked')
      : null;

    // Fallback: primer radio marcado que NO esté en un bloque oculto.
    if (!radio) {
      var radios = fs.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        if (!radios[i].closest('.shopify_subscriptions_app_block--hidden, [aria-hidden="true"]')) {
          radio = radios[i];
          break;
        }
      }
    }
    if (!radio) return null;

    var group = radio.closest('.subscription_group') || radio.closest('.plan_card');
    if (!group) return null;

    var priceEl = group.querySelector('.in_widget_price');
    if (!priceEl) return null;

    var txt = priceEl.textContent.replace(/\s+/g, ' ').trim();
    txt = txt.replace(/\s*[A-Z]{3}\s*$/, '').trim(); // quitar código ISO (EUR, USD...)
    return txt || null;
  }

  // Idempotente: escribe solo si difiere (permite re-corregir cuando el tema resetea a "Desde").
  function syncPrice() {
    // Si hay selector de packs (variantes), ese bloque gestiona el precio del boton. No interferir.
    if (document.querySelector('[class*="ps-wrapper-"]')) return;
    var newPrice = getActivePriceText();
    if (!newPrice) return;
    document.querySelectorAll(BUTTON_PRICE).forEach(function (target) {
      if (target.textContent !== newPrice) target.textContent = newPrice;
    });
  }

  function syncSoon() {
    syncPrice();
    [0, 60, 160, 320, 600].forEach(function (d) { setTimeout(syncPrice, d); });
  }

  function attachListeners(fieldset) {
    if (fieldset.dataset.iuropPriceSyncBound === 'true') return;
    fieldset.dataset.iuropPriceSyncBound = 'true';

    fieldset.addEventListener('change', syncSoon);
    fieldset.addEventListener('click', function () { setTimeout(syncPrice, 50); });

    // El widget actualiza precios al cambiar de variante/plan -> re-sincronizar.
    new MutationObserver(syncPrice).observe(fieldset, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['checked', 'class', 'aria-checked', 'aria-hidden']
    });

    // El <product-price> del tema resetea el botón a "Desde X" al cambiar variante
    // (porque el producto tiene precios que varían) -> observar el botón y re-corregir.
    document.querySelectorAll('add-to-cart-component, .add-to-cart-text__content').forEach(function (node) {
      new MutationObserver(syncPrice).observe(node, {
        childList: true, subtree: true, characterData: true
      });
    });

    // El cambio de variante en el selector nativo dispara 'change' (lo proxea el selector de packs).
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker, input[name="id"]')) {
        syncSoon();
      }
    });

    syncSoon();
  }

  function init() {
    var fieldset = document.querySelector(SOURCE_FIELDSET);
    if (fieldset) {
      attachListeners(fieldset);
      return true;
    }
    return false;
  }

  if (init()) return;

  // El widget se inyecta async — esperamos a que aparezca.
  var bodyObserver = new MutationObserver(function () {
    if (init()) bodyObserver.disconnect();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { bodyObserver.disconnect(); }, 20000);
})();
